import { Navigate, useParams, useSearchParams } from "react-router-dom";

/** Old shift links open the manager in shift mode, keeping the inspection. */
export const TestShackManagerShiftRedirect = ({
	managerRoute,
}: {
	managerRoute: string;
}) => {
	const { shiftId } = useParams();
	const [params] = useSearchParams();
	const inspection = params.get("inspection");

	return (
		<Navigate
			replace
			to={`${managerRoute}?mode=shift&shift=${shiftId}${
				inspection ? `&inspection=${inspection}` : ""
			}`}
		/>
	);
};
